(() => {
  const DESKTOP_QUERY = '(min-width: 990px)';
  const ENTER_AT = 38;
  const EXIT_AT = 14;

  const mountLiquidHeader = () => {
    const header = document.querySelector('[data-site-header]');
    if (!header || header.dataset.liquidHeaderReady === 'true') return;

    header.dataset.liquidHeaderReady = 'true';
    header.classList.add('af-liquid-header-ready');

    const host = header.parentElement;
    if (host) host.classList.add('af-liquid-header-host');

    const desktop = window.matchMedia(DESKTOP_QUERY);
    let compact = false;
    let ticking = false;

    const closePanels = () => {
      header.querySelectorAll('details[open]').forEach((details) => {
        details.removeAttribute('open');
      });
    };

    const render = () => {
      ticking = false;
      const shouldCompact = desktop.matches &&
        window.scrollY > (compact ? EXIT_AT : ENTER_AT);

      if (shouldCompact === compact) return;
      compact = shouldCompact;

      if (compact) closePanels();
      header.classList.toggle('is-liquid-nav', compact);
      host?.classList.toggle('is-liquid-header-host-compact', compact);
      document.documentElement.classList.toggle('af-liquid-header-active', compact);
    };

    const schedule = () => {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(render);
    };

    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule, { passive: true });

    if (typeof desktop.addEventListener === 'function') {
      desktop.addEventListener('change', schedule);
    } else if (typeof desktop.addListener === 'function') {
      desktop.addListener(schedule);
    }

    render();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mountLiquidHeader, { once: true });
  } else {
    mountLiquidHeader();
  }

  document.addEventListener('shopify:section:load', mountLiquidHeader);
})();
